import { render, staticRenderFns } from "./CrFooter.vue?vue&type=template&id=7931488a&scoped=true"
import script from "./CrFooter.vue?vue&type=script&lang=js"
export * from "./CrFooter.vue?vue&type=script&lang=js"
import style0 from "./CrFooter.vue?vue&type=style&index=0&id=7931488a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7931488a",
  null
  
)

export default component.exports